// Configuration de l'API
// export const API_BASE_URL = 'https://localhost:7282';

// Alternative pour la production
export const API_BASE_URL = 'https://webappdomotiqueapi.azurewebsites.net';
